export default "__VITE_ASSET__CMBS0O8A__"